module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-select",
    class: _vm.formClasses
  }, [(_vm.label) ? _c('label', {
    staticClass: "form-select__label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.required) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('input-hidden', {
    attrs: {
      "value": _vm.value,
      "name": _vm.name
    }
  }), _c('element-container', {
    staticClass: "form-select__value",
    class: {
      disabled: _vm.disabled
    },
    attrs: {
      "cursor": _vm.readonly
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "form-select__button",
    class: {
      "form-select__button_opened": _vm.opened
    }
  }) : _vm._e(), (_vm.selected) ? _c('div', {
    staticClass: "form-select__selected",
    attrs: {
      "title": _vm.selected
    }
  }, [_vm._v(_vm._s(_vm.selected))]) : _c('div', {
    staticClass: "form-select__placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))])]), (!_vm.readonly) ? _c('element-container', {
    staticClass: "form-select__options",
    class: _vm.containerClasses
  }, [(_vm.filtering) ? _c('div', {
    staticClass: "form-select__filter-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    ref: "input",
    staticClass: "form-select__filter-input",
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]) : _vm._e(), (_vm.filtering && _vm.filtered.length === 0) ? _c('div', {
    staticClass: "form-select__no-options"
  }, [_vm._v(_vm._s(_vm.filterText))]) : _vm._e(), _c('div', {
    staticClass: "form-select__options-container",
    class: _vm.scrollClasses,
    style: (_vm.styles)
  }, [_c('div', {
    ref: "options",
    staticClass: "form-select__options-scroll"
  }, [_vm._l((_vm.filtered), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "form-select__option",
      class: {
        "form-select__option_selected": _vm.isSelected(option.value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.input(option)
        }
      }
    }, [_vm._v(_vm._s(option.text))])
  }), (_vm.addText) ? _c('div', {
    staticClass: "form-select__add",
    on: {
      "click": function($event) {
        return _vm.$emit("add")
      }
    }
  }, [_vm._v(_vm._s(_vm.addText))]) : _vm._e()], 2)])]) : _vm._e(), (_vm.vError) ? _c('div', {
    staticClass: "form-select__text"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79993615","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Select.vue
// module id = 2572a324f3746ec5d921
// module chunks = 89